<template>
  <div>
    <LandingPageBody v-bind="landingPageProps" />
  </div>
</template>

<script>
import LandingPageBody from '@/components/CampaignLandingPage/LandingPageBody'
import { LandingPageType } from '@/enums/landing'
import { MembershipTypes } from '@/enums/member'
import { AUTH_ID, AUTH_USER } from '@/utils/store/getterTypes'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'AddUndershirtsLandingPage',
  layout: 'homepage-signup-button',
  components: {
    LandingPageBody
  },
  computed: {
    landingPageProps () {
      return {
        locizePath: 'LandingPage.AddUndershirts',
        imagePath: '/images/frontend/undershirts/',
        appCountry: this.country,
        locale: this.locale,
        userIdentifier: this.userId,
        landingpageUrl: '/add-undershirts',
        primaryColor: '#181818',
        type: LandingPageType.addMembership,
        authUser: this.authUser,
        membershipTypeReference: MembershipTypes.undershirts,
        getSizeOptions: this.getSizeOptions
      }
    },
    sizeOptions () {
      return [
        {
          value: 'men-undershirt-xs',
          label: 'XS'
        },
        {
          value: 'men-undershirt-s',
          label: 'S'
        },
        {
          value: 'men-undershirt-m',
          label: 'M'
        },
        {
          value: 'men-undershirt-l',
          label: 'L'
        },
        {
          value: 'men-undershirt-xl',
          label: 'XL'
        },
        {
          value: 'men-undershirt-xxl',
          label: 'XXL'
        },
        {
          value: 'men-undershirt-3xl',
          label: '3XL'
        }
      ]
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    ...mapGetters('auth', {
      userId: AUTH_ID,
      authUser: AUTH_USER
    })
  },
  methods: {
    getSizeOptions () {
      return this.sizeOptions
    }
  }
}
</script>

<style>

</style>
